<template>
  <transition name="slide">
    <div class="seating-cont">
      <div @click="toggle = !toggle" class="seating-header">
        <div class="seating-name">{{ type }}</div>
        <div class="seating-detail">
          <div>{{seats}} Guest</div>
          <div>{{ count }} PCS</div>
        </div>
      </div>
      <div v-if="toggle">
        <div class="seating-body">
          <div class="seating-row">
            <div class="seating-col">
              Seating Type
            </div>
            <div class="seating-col">
              <input type="text" v-model="type"
                     name="Type"
                     v-validate="'required'"/>
              <span class="text-danger text-sm"
                    v-show="errors.has('Type')">{{ errors.first('Type') }}</span>
            </div>
          </div>
          <div class="seating-row">
            <div class="seating-col">
              Seating Size
            </div>
            <div class="seating-col">
              <select v-model="seats">
                <option value="1">1 Guest</option>
                <option value="2">2 Guest</option>
                <option value="3">3 Guest</option>
                <option value="4">4 Guest</option>
                <option value="5">5 Guest</option>
                <option value="6">6 Guest</option>
                <option value="7">7 Guest</option>
                <option value="8">8 Guest</option>
                <option value="9">9 Guest</option>
                <option value="10">10 Guest</option>
              </select>
            </div>
          </div>
          <div class="seating-row">
            <div class="seating-col">
              Seating Quantity
            </div>
            <div class="seating-col">
              <input type="number" v-model="count">
            </div>
          </div>
        </div>
        <div class="seating-options">
          <div v-if="!seating._id" class="r-save-button" @click="saveSeating"><i class="fas fa-save"></i> Save</div>
          <div v-else class="r-save-button" @click="editSeating"><i class="fas fa-edit"></i> Edit</div>
          <div class="r-save-button" @click="deleteSeating"><i class="fas fa-trash-alt"></i> Delete</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from '../../axios'
export default {
  props: {
    seating: {
      type: Object
    },
    finished: {
      type: Function
    }
  },
  name: 'SeatingItem',
  components: {
    axios
  },
  data () {
    return {
      toggle: !this.seating._id,
      type: '',
      seats: 1,
      count: 1
    }
  },
  computed: {
    token () {
      return this.$store.state.api.reservationToken
    },
    reservationData () {
      return this.$store.state.api.reservationData
    },
    reservationStore: {
      get () {
        return this.$store.state.api.reservationStore
      },
      set (val) {
        this.$store.commit('api/SET_RESERVATION_STORE', val)
      }
    }
  },
  methods: {
    loadData () {
      const { seats, type, count } = JSON.parse(JSON.stringify(this.seating))
      this.seats = seats
      this.type = type
      if (count) {
        this.count = count
      }
    },
    deleteSeating () {
      axios
        .delete(`https://reservations.authorizelocal.com/api/seating/${this.seating._id}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
          }
        })
        .then(response => {
          if (response.data.status) {
            this.getStore()
            this.$vs.notify({
              title: 'Success',
              text: 'Delete successfully',
              iconPack: 'feather',
              icon: 'icon-alert-check',
              color: 'success'
            })
          }
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Could not save seating',
            text: 'Seating error',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getStore () {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios
            .get(`https://reservations.authorizelocal.com/api/store/${this.reservationStore.id}`, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
              }
            })
            .then(response => {
              if (response.data.status) {
                this.reservationStore = response.data.data
                this.finished()
              }
            })
            .catch(() => {
              this.$vs.notify({
                title: 'Could not fetch store info',
                text: 'Store error',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
        }
      })
    },
    saveSeating () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const payload = {
            seats: this.seats,
            type: this.type,
            count: this.count,
            store: this.reservationStore.id
          }
          axios
            .post('https://reservations.authorizelocal.com/api/seating', payload, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
              }
            })
            .then(response => {
              if (response.data.status) {
                this.getStore()
                this.$vs.notify({
                  title: 'Success',
                  text: 'Saved successfully',
                  iconPack: 'feather',
                  icon: 'icon-alert-check',
                  color: 'success'
                })
              }
            })
            .catch(() => {
              this.$vs.notify({
                title: 'Could not save seating',
                text: 'Seating error',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
        }
      })
    },
    editSeating () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const payload = {
            seats: this.seats,
            type: this.type,
            count: this.count
          }
          axios
            .put(`https://reservations.authorizelocal.com/api/seating/${this.seating._id}`, payload, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
              }
            })
            .then(response => {
              if (response.data.status) {
                this.getStore()
                this.$vs.notify({
                  title: 'Success',
                  text: 'Updated successfully',
                  iconPack: 'feather',
                  icon: 'icon-alert-check',
                  color: 'success'
                })
              }
            })
            .catch(() => {
              this.$vs.notify({
                title: 'Could not save seating',
                text: 'Seating error',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
        }
      })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss">
.enter { transform: translateX(100%) }
.enter-to { transform: translateX(0) }
.slide-enter-active { position: absolute }

.leave { transform: translateX(0) }
.leave-to { transform: translateX(-100%) }

.slide-enter-active,
.slide-leave-active { transition: all 750ms ease-in-out }
</style>
